import { render, staticRenderFns } from "./SvehiclesalesreceiptCreate.vue?vue&type=template&id=6772724f&scoped=true"
import script from "./SvehiclesalesreceiptCreate.vue?vue&type=script&lang=js"
export * from "./SvehiclesalesreceiptCreate.vue?vue&type=script&lang=js"
import style0 from "./SvehiclesalesreceiptCreate.vue?vue&type=style&index=0&id=6772724f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6772724f",
  null
  
)

export default component.exports